<template>
<div>
    <div class="container mt-4">
        <b-alert show class="text-center" v-if="Checkout.company">{{Checkout.company.Name}}</b-alert>
        <!-- <b-alert show class="text-center" v-else>no Company Missing</b-alert> -->

        <b-card bg-variant="light" v-if="Checkout.shippingAddress">
            <b-form-group horizontal
                            breakpoint="lg"
                            label="Shipping Address"
                            label-size="lg"
                            label-class="font-weight-bold pt-0"
                            class="mb-0">
                <b-form-group horizontal
                            label="Full Name:"
                            label-class="text-sm-left"
                            label-for="shippingFullName">
                <b-form-input id="shippingFullName" v-model="Checkout.shippingAddress.FullName"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="Line 1:"
                            label-class="text-sm-left"
                            label-for="nestedStreet">
                <b-form-input id="nestedStreet" v-model="Checkout.shippingAddress.Line1"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="Line 2:"
                            label-class="text-sm-left"
                            label-for="nestedStreet">
                <b-form-input id="nestedStreet" v-model="Checkout.shippingAddress.Line2"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="Line 3:"
                            label-class="text-sm-left"
                            label-for="nestedStreet">
                <b-form-input id="nestedStreet" v-model="Checkout.shippingAddress.Line3"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="City:"
                            label-class="text-sm-left"
                            label-for="nestedCity">
                <b-form-input id="nestedCity" v-model="Checkout.shippingAddress.City"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="State:"
                            label-class="text-sm-left"
                            label-for="nestedState">
                <b-form-input id="nestedState" v-model="Checkout.shippingAddress.State"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="Postcode:"
                            label-class="text-sm-left"
                            label-for="nestedPostcode">
                <b-form-input id="nestedPostcode" v-model="Checkout.shippingAddress.Postcode"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="Country:"
                            label-class="text-sm-left"
                            label-for="nestedCountry">
                <b-form-input id="nestedCountry" v-model="Checkout.shippingAddress.Country"></b-form-input>
                </b-form-group>
            </b-form-group>
        </b-card>
        <b-card bg-variant="light" v-if="Checkout.shippingAddress">
            <b-form-group horizontal
                            breakpoint="lg"
                            label="Details"
                            label-size="lg"
                            label-class="font-weight-bold pt-0"
                            class="mb-0">
                <b-form-group horizontal
                    label="Purchase Order:"
                    label-class="text-sm-left"
                    label-for="checkout-po">
                <b-form-input id="checkout-po" v-model="Checkout.po"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="Comments:"
                            label-class="text-sm-left"
                            label-for="checkout-comments">
                <b-form-textarea id="checkout-comments" v-model="Checkout.comments"></b-form-textarea>
                </b-form-group>
            </b-form-group>
        </b-card>

        <b-card bg-variant="light" v-if="!Checkout.shippingAddress">
          No shipping address listed. Please go to your profile and add a Shipping Address, then check out again.
        </b-card>
        
        <b-btn v-on:click="SubmitOrder" :disabled="isOrderSubmitting || noShippingAddress">{{buttonText}}</b-btn>
    </div>
  <div class="splash-overlay d-flex fixed-bottom fixed-top" v-if="orderSplashVisible">
    <div class="splash-card bg-white m-auto text-center">
      <div class="h2">Order Submitted</div> 
      <div class="pb-3">Order {{orderNumber}} has been submitted.</div>
      <div>
        <b-btn to="/">Close</b-btn>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import store from "@/store.js";
import CheckoutService from "../services/CheckoutService";

import ShowPrices from '@/mixins/ShowPrices';

export default {
  name: "Checkout",
  data() {
    return {
      buttonText: 'Submit Order',
      isOrderSubmitting: false,
      orderNumber: null,
      orderSplashVisible: false
    };
  },
  computed: {
    Items() {
      return store.state.cart;
    },
    Checkout() {
      return store.state.checkout;
    },
    CartTotal() {
        return this.$store.state.cart.reduce((total, item) => total + (item.Price * item.Qty), 0);
    },
    noShippingAddress() {
      return !this.Checkout.shippingAddress;
    }
  },
  beforeRouteEnter(to, from, next) {
    if(store.state.checkout.checkoutStarted) {
        CheckoutService.UpdateCartPrices().then(() => {
        next();
        });
    }
    else {
        next({name: 'Cart'});
    }
  },
  beforeRouteUpdate(to, from, next) {
    CheckoutService.UpdateCartPrices().then(() => {
      next();
    });
  },
  methods: {
    SubmitOrder() {
      this.buttonText = 'Processing...';
      this.isOrderSubmitting = true;
      CheckoutService.SubmitOrder(
        response => {
          this.orderNumber = response.QuoteNumber;
          this.orderSplashVisible = true;
          this.$store.commit("ClearCart");
        },
        error => {
          this.$toasted
            .error(`Unable to submit order: ${error.Error}. Please call 02 8850 7992.`)
            .goAway(10000);
          this.isOrderSubmitting = false;
          this.buttonText = 'Submit Order';
        }
      );
    }
  },
  mixins: [ShowPrices]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card:hover {
  background: #f1f2f6;
  cursor: pointer;
}

.splash-overlay{
  background: rgba(68, 68, 68, 0.808);
}

.splash-card{
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/checkout.vue